export default "__VITE_ASSET__d1a9eb45__"